import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-prepaid-intro',
  templateUrl: './prepaid-intro.component.html',
  styleUrls: ['./prepaid-intro.component.css']
})
export class PrepaidIntroComponent implements OnInit {

  constructor(
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Prepaid Intro| Line Clear Express")
  }

  goToTnc(){
    //this.route.navigate(['tnc']);
    window.open('https://lineclearexpress.com/doc/Terms_and_Conditions.pdf', '_blank');
  }

  prepaid() {
    window.open('https://lineclearexpress.com/doc/About_Line_Clear_Express_Prepaid.pdf', '_blank');
  }

}

